import { render } from "./MediaStats.vue?vue&type=template&id=5db7a24a&scoped=true"
import script from "./MediaStats.vue?vue&type=script&lang=js"
export * from "./MediaStats.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-5db7a24a"

export default script